var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.0331L12.5 14.0331L22.5 4.03308",
    stroke: "current",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12.0331V19.0331C21.5 19.5635 21.2893 20.0722 20.9142 20.4473C20.5391 20.8224 20.0304 21.0331 19.5 21.0331H5.5C4.96957 21.0331 4.46086 20.8224 4.08579 20.4473C3.71071 20.0722 3.5 19.5635 3.5 19.0331V5.03308C3.5 4.50265 3.71071 3.99394 4.08579 3.61887C4.46086 3.24379 4.96957 3.03308 5.5 3.03308H16.5",
    stroke: "current",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquare);
export default __webpack_public_path__ + "static/media/check-square.831273db38a877e802ac54f87d8eb3e1.svg";
export { ForwardRef as ReactComponent };